import React from "react";
import { Div } from "glamorous";
import PropTypes from "prop-types";
import { post } from "../../misc/api";
import validate from "../../misc/validate";
import data from "../../data";
import styles from "../../styles";
import { track, getOrientation } from "../../misc/utils";

const Upload = ({ setLoading, setImage, setError, setArea }) => {
  let theForm;

  return (
    <Div width="100%">
      <form ref={form => (theForm = form)} encType="multipart/form-data">
        <input
          name="image"
          onChange={ev =>
            handleChange({
              theForm,
              file: ev.target.files[0],
              setLoading,
              setImage,
              setError,
              setArea
            })
          }
          type="file"
          ref={input => (this.theInputFile = input)}
          style={{ display: "none" }}
        />
        <Div
          onClick={() => {
            track.event("button", "click", "Upload_Photo");
            this.theInputFile.click();
          }}
          css={styles.ctas.initial}
        >
          {data.copy("uploadPhotoBtn")}
        </Div>
      </form>
    </Div>
  );
};

async function handleChange({
  theForm,
  file,
  setLoading,
  setImage,
  setError,
  setArea
}) {
  const validateResponse = validate.file(file);

  if (!validateResponse.isValid) {
    setError({
      heading: data.copy("sorry"),
      title: data.copy("uploadFailed"),
      message: validateResponse.error,
      cta: data.copy("chooseAnother"),
      prevArea: "Landing"
    });
    setArea("Error");
    return;
  }

  const orientation = await getOrientation(file);

  setLoading(data.copy("uploading"));

  try {
    const response = await post(`upload/${orientation}`, new FormData(theForm));

    setLoading(false);

    if (response.status !== "ok") {
      throw new Error(response.message);
    }

    setImage("origin", { src: response.url, uploaded: true });
    setImage("result", { src: response.url });
    setArea("CropPhoto");
  } catch (err) {
    setLoading(false);

    setError({
      header: "Sorry",
      title: "THERE WAS A PROBLEM UPLOADING YOUR IMAGE",
      message: "Please try again or select an alternative photo",
      cta: "Back",
      prevArea: "Landing"
    });

    setArea("Error");
  }
}

Upload.propTypes = {
  setLoading: PropTypes.func.isRequired,
  setImage: PropTypes.func.isRequired,
  setArea: PropTypes.func.isRequired
};

export default Upload;



// WEBPACK FOOTER //
// ./src/components/areas/Upload.js